import type { FCWithChildren } from "koljobs-types";

import { AuthCard, AuthCardProps } from "@/features/auth/components/AuthCard";
import { AuthFooter } from "@/features/auth/components/AuthFooter";
import { BackableNavBar } from "@/features/layout/components/mobile/BackableNavBar";

export const AuthLayout: FCWithChildren<
  { hasFooter?: boolean } & AuthCardProps
> = ({ authType, children, hasFooter }) => {
  return (
    <div className="bg-secondary relative flex min-h-screen flex-col justify-between space-y-5 pb-6 sm:h-screen sm:justify-center sm:space-y-0">
      <div className="sm:hidden">
        <BackableNavBar title={authType === "signin" ? "登入" : "註冊"} />
      </div>

      <AuthCard authType={authType}>{children}</AuthCard>

      <div className="mx-9 sm:hidden">
        {hasFooter && <AuthFooter isMobile />}
      </div>
    </div>
  );
};
